var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54827 0.951054C8.84629 0.0269711 10.1537 0.0269716 10.4517 0.951055L11.8446 5.26994C11.9781 5.68379 12.3637 5.96395 12.7985 5.963L17.3364 5.95308C18.3074 5.95096 18.7114 7.19439 17.9246 7.76338L14.2475 10.4227C13.8952 10.6775 13.7479 11.1308 13.8832 11.5441L15.2949 15.8568C15.597 16.7796 14.5392 17.5481 13.755 16.9757L10.0896 14.3003C9.73832 14.0439 9.26168 14.0439 8.91045 14.3003L5.24502 16.9757C4.46075 17.5481 3.40303 16.7796 3.70509 15.8568L5.11682 11.5441C5.25209 11.1308 5.1048 10.6775 4.75246 10.4227L1.07537 7.76338C0.288607 7.19439 0.692621 5.95096 1.66357 5.95308L6.20149 5.963C6.63633 5.96395 7.02194 5.68379 7.15541 5.26994L8.54827 0.951054Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGray);
export default __webpack_public_path__ + "static/media/star_gray.9c5c1f33f01ec6af0c692136e765df71.svg";
export { ForwardRef as ReactComponent };